module.exports = "/build/web/svg/social/small/youtube.18abb6f5172fef08b0f0fe2fc89d368d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/youtube.svg
// module id = 198
// module chunks = 24